import React from 'react';
import { TractNRIFormulaData } from 'components/tract-nri-card';
import {
  AcreageUnitInterestFormula,
  LateralUnitInterestFormula,
} from './calculation-builder';
import { BaseCard } from 'components/base-card';
import { UnitInterestCardContent } from './unit-interest-card-content';
import style from './unit-interest-card.module.scss';

interface UnitInterestCardProps {
  unitInterestValue: number | null;
  activeAllocationMethod: 'acreage' | 'lateral_length';
  lateralUnitInterestFormula: LateralUnitInterestFormula | null;
  acreageUnitInterestFormula: AcreageUnitInterestFormula | null;
  hasAllocationManager: boolean;
  calculationMethod: 'nra' | 'nma';
  tractNRIFormula: TractNRIFormulaData | null;
  renderTrigger: (active: boolean, toggle: () => void) => React.ReactNode;
  participationFactorOverridden?: boolean;
  title: string;
}

export const UnitInterestCard: React.FC<UnitInterestCardProps> = ({
  unitInterestValue,
  activeAllocationMethod,
  lateralUnitInterestFormula,
  acreageUnitInterestFormula,
  hasAllocationManager,
  calculationMethod,
  tractNRIFormula,
  renderTrigger,
  participationFactorOverridden,
  title = 'Unit NRI Calculation',
}) => (
  <span className={style.unitInterestCardWrapper}>
    <BaseCard
      contentClassName={`${style.unitInterestCardContent}`}
      triggerClassName={style.unitInterestCardTrigger}
      renderTrigger={renderTrigger}
      content={
        <UnitInterestCardContent
          unitInterestValue={unitInterestValue}
          activeAllocationMethod={activeAllocationMethod}
          lateralUnitInterestFormula={lateralUnitInterestFormula}
          acreageUnitInterestFormula={acreageUnitInterestFormula}
          hasAllocationManager={hasAllocationManager}
          calculationMethod={calculationMethod}
          tractNRIFormula={tractNRIFormula}
          participationFactorOverridden={participationFactorOverridden}
          title={title}
        />
      }
    />
  </span>
);
